/* TRU "Complete your build" add-ons (snippets/tru-addons.liquid, REDESIGN_REQUIREMENTS.md section 3).
   - Keeps a running "Add-ons selected" total.
   - Hides the Shop Pay / "More payment options" button while any add-on is checked (that button
     would buy only the kit).
   - With add-ons checked, Add to Cart sends one /cart/add.js request: the kit with its normal
     quantity and properties, plus each checked add-on at quantity 1 with "_Add-on for" = kit SKU.
     Then it goes to the cart page like the theme's own button (cart_type "page"), or opens the
     cart notification/drawer if the store switches to one.
     With nothing checked the theme's own Add to Cart runs untouched. */
(function () {
  var box = document.querySelector('[data-tru-addons]');
  if (!box) return;
  var info = box.closest('.product__info-container') || document;
  var totalLine = box.querySelector('.tru-ao__total');
  var totalEl = box.querySelector('[data-tru-ao-total]');
  var skus = {};
  try { skus = JSON.parse(box.querySelector('[data-tru-ao-skus]').textContent); } catch (e) {}
  var fmt;
  try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }); } catch (e) {}
  function money(cents) { return fmt ? fmt.format(cents / 100) : '$' + (cents / 100).toFixed(2); }

  function checked() { return Array.prototype.slice.call(box.querySelectorAll('.tru-ao__cb:checked')); }
  function sync() {
    var c = checked();
    var sum = c.reduce(function (a, cb) { return a + (parseInt(cb.getAttribute('data-price'), 10) || 0); }, 0);
    totalEl.textContent = money(sum);
    totalLine.hidden = c.length === 0;
    document.documentElement.classList.toggle('tru-ao-on', c.length > 0);
  }
  box.addEventListener('change', function (e) { if (e.target.classList && e.target.classList.contains('tru-ao__cb')) sync(); });
  window.addEventListener('pageshow', sync);
  sync();

  /* Runs before the theme's own submit handler (capture phase) and only takes over when add-ons are checked. */
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var pf = form.closest('product-form');
    if (!pf || !info.contains(pf)) return;
    var picks = checked();
    if (!picks.length) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();

    var btn = pf.submitButton || form.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    if (pf.handleErrorMessage) pf.handleErrorMessage();
    var spinner = pf.querySelector('.loading-overlay__spinner');
    if (btn) { btn.setAttribute('aria-disabled', true); btn.classList.add('loading'); }
    if (spinner) spinner.classList.remove('hidden');

    var fd = new FormData(form);
    var kitId = parseInt(fd.get('id'), 10);
    var kit = { id: kitId, quantity: parseInt(fd.get('quantity'), 10) || 1 };
    var props = {};
    fd.forEach(function (val, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && typeof val === 'string' && val !== '') props[m[1]] = val;
    });
    if (Object.keys(props).length) kit.properties = props;
    if (fd.get('selling_plan')) kit.selling_plan = fd.get('selling_plan');
    var kitSku = skus[String(kitId)] || '';
    /* The cart lists the newest line first, so the kit goes last in the request: it then shows on
       top of the cart with its add-ons under it, in the order they appear on the page. */
    var items = picks.map(function (cb) {
      return { id: parseInt(cb.value, 10), quantity: 1, properties: { '_Add-on for': kitSku } };
    }).reverse().concat([kit]);

    var cart = pf.cart || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: items };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (pf.handleErrorMessage) pf.handleErrorMessage(res.description || res.message);
          return;
        }
        /* They're in the cart now: clear the boxes so going Back to this page can't add them twice. */
        picks.forEach(function (cb) { cb.checked = false; });
        sync();
        if (!cart) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
        var lines = res.items || [];
        var kitLine = lines.filter(function (i) { return i.variant_id === kitId && !(i.properties && i.properties['_Add-on for']); })[0] || lines[lines.length - 1] || {};
        res.key = kitLine.key;
        res.id = kitLine.variant_id || kitId;
        cart.renderContents(res);
      })
      .catch(function (e) {
        console.error(e);
        if (pf.handleErrorMessage) pf.handleErrorMessage('Something went wrong. Please try again.');
      })
      .finally(function () {
        if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); }
        if (spinner) spinner.classList.add('hidden');
        if (cart && cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      });
  }, true);
})();
